const binding = { modules: {}, dataActions: {} };

    (binding.modules['eve-help'] = {
        c: () => require('partner/modules/eve-help/eve-help.tsx'),
        $type: 'containerModule',
        da: [],
        
        iNM: false,
        ns: '__local__',
        n: 'eve-help',
        p: '__local__',
        
        pdp: '',
        
        
        md: 'src/modules/eve-help'
    });
        

        
    window.__bindings__ = window.__bindings__ || {};
    window.__bindings__.modules = {
        ...window.__bindings__.modules || {},
        ...binding.modules
    };
    
        window.__bindings__.dataActions = {
        ...window.__bindings__.dataActions || {},
        ...binding.dataActions
    };
                        export const viewDictionary = {};
                        viewDictionary['__local__|__local__|modules|eve-help|eve-help'] = {
                c: () => require('partner/modules/eve-help/eve-help.view.tsx'),
                cn: '__local__-__local__-eve-help'
            };
window.__bindings__ = window.__bindings__ || {};
window.__bindings__.viewDictionary = {
                        ...window.__bindings__.viewDictionary || {},
                        ...viewDictionary
                    };